/* eslint-disable react-hooks/exhaustive-deps */
import '../../../../scss/components/_icons.scss';
import '../../../../scss/components/_list-header.scss';

import { Button, DeleteModal, Status, Toggle } from '@finpay-development/shared-components';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import LockIcon from '@mui/icons-material/Lock';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import RefreshIcon from '@mui/icons-material/Refresh';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { Box, Divider, Fade, Grid, IconButton, Menu, MenuItem, Typography, Skeleton } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import * as Yup from 'yup';

import LockModal from '../../../../implementation-specialist/components/locks/lock-modal';
import AccessControl from '@finpay-development/shared-platform/lib/esm/security/components/access-control';
import { RolePageNames } from '@finpay-development/shared-platform/lib/esm/security/model/role-page-names';
import { formatNumberToUSD } from '@finpay-development/shared-platform/lib/esm/shared/calculators';
import { configSettings } from '@finpay-development/shared-platform/lib/esm/shared/configuration/config-settings';
import { ApiBatchLimits, clipboardKeys, formats, highRiskMessage, StatusColors, userRoles } from '@finpay-development/shared-platform/lib/esm/shared/enums';
import { Clipboard, EmptyClipBoard } from '@finpay-development/shared-platform/lib/esm/shared/model/clipboard';
import { RootState } from '../../../../shared/state/root-reducer';
import { AppDispatch } from '../../../../shared/state/store';
import { Utils } from '@finpay-development/shared-platform/lib/esm/shared/utils';
import { LedgerUtils } from '@finpay-development/shared-platform/lib/esm/shared/ledger-utils';
import { patientHelper, patientService } from '@finpay-development/shared-platform/lib/esm/patient/services/patient-service';
import {
  resetPatientRecordLockingContext,
  setInUseModalOpen_paymentPrograms,
  setIsPaymentProgramsModalOpen,
  setLockRequestedById,
  setLockStatusReleased_paymentPrograms,
  setRequestDeniedModalOpen_paymentPrograms,
} from '@finpay-development/shared-platform/lib/esm/patient/state/patient-record-locking-slice';
import {
  denyRequestOk,
  editModalPoll,
  releaseRecordOk,
  requestReleaseOk,
} from '../../../state/patient-record-locking-thunk';
import { resetPatientContext, setDownPaymentFullyPaid } from '@finpay-development/shared-platform/lib/esm/patient/state/patient-slice';
import {
  deletePatientPaymentMethod,
  getInstanceOfCare, // Used for v2 modal
  getPaymentMethods,
  lockIOC,
  releaseCharge,
  resendPaymentReceipt,
  resendRefundReceipt,
} from '@finpay-development/shared-platform/lib/esm/patient/state/patient-thunk';
import { LockablePatientRecordSection } from '../../models/lockable-patient-record-section';
import { PatientPaymentProgram } from '@finpay-development/shared-platform/lib/esm/patient/components/models/patient-payment-program';
import { Payment, V2PaymentDetail } from '@finpay-development/shared-platform/lib/esm/patient/components/models/payment';
import { PAYMENT_METHOD_TYPES } from '@finpay-development/shared-platform/lib/esm/patient/components/models/payment-method';
import { PaymentStatus } from '@finpay-development/shared-platform/lib/esm/patient/components/models/payment-status';
import { StripePaymentMethod } from '@finpay-development/shared-platform/lib/esm/patient/components/models/stripe-payment-method';
import { HighRiskModal } from './high-risk-modal';
import { PaymentProgramsModal } from './payment-programs-modal';
import { RecurringPaymentModal } from './recurring-payment-modal';
import { ClientCrm, ClientStatusCardViewModel } from '@finpay-development/shared-platform/lib/esm/shared/model/client-status-card';
import { showErrorStatus } from '@finpay-development/shared-platform/lib/esm/security/state/user-slice';
import { userService } from '@finpay-development/shared-platform/lib/esm/admin/services/admin-user-service';
import { UserInfoClient } from '@finpay-development/shared-platform/lib/esm/admin/models/user-info-client';
import { DetailedLedger } from '@finpay-development/shared-platform/lib/esm/shared/model/ledger';
import { PAYMENT_TYPES } from '@finpay-development/shared-platform/lib/esm/patient/components/models/payment-type';
import TransactionMenu from '@finpay-development/shared-platform/lib/esm/shared/components/transaction-menu';
import ResendReceiptModal from '@finpay-development/shared-platform/lib/esm/patient/components/patient-drilldown/transactions/resend-receipt-modal';
import { ClientBusinessRules } from '@finpay-development/shared-platform/lib/esm/shared/model/client';


type MenuActions = "Release" | "Delete";
let editModalPollingInterval: any; // an interval assigned via setInterval

// if there are no champions, pre-select the selected patient


interface ProgramAccordionProps {
  isCovertDisabled: boolean;
  isPaymentProgramV5: boolean;
  setIsMissingReqModalOpen: (value: boolean, isEnrollFlow?: boolean) => void;
  isFetchingLedgerDetails: boolean;
  ledgerData?: { ledger: DetailedLedger[] };
}

const PaymentProgramAccordionContents = (props: ProgramAccordionProps) => {
  const countdownMax = configSettings.REACT_APP_patient_locking_countdown_max;
  const lockPollingInterval = configSettings.REACT_APP_patient_locking_polling_interval;

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const [clipboard, setClipboard] = useState("")
  const [copiedToClipboardMsg, setCopiedToClipboardMsg] = useState(false)
  const [isReceiptModalOpen, setIsReceiptModalOpen] = useState(false);

  const { isCovertDisabled, isPaymentProgramV5, setIsMissingReqModalOpen, isFetchingLedgerDetails, ledgerData } = props;

  // Get detailed ledger from Redux store
  const detailedLedger = useSelector((state: RootState) => 
    state.patientContext.selectedEncounter?.encounterLedger?.ledger || []
  ) as DetailedLedger[];

  // Get centralized downpayments from Redux store  
  const selectedIocDownPmts = useSelector((state: RootState) => 
    state.patientContext.selectedEncounter?.encounterLedger?.downpayments || []
  ) as DetailedLedger[];

  // Get centralized downpayments sum from Redux store
  const selectedIocDownPmtsSum = useSelector((state: RootState) => 
    state.patientContext.selectedEncounter?.encounterLedger?.downpaymentsSum || 0
  ) as number;

  // Add a state to track type 1 payments from detailedLedger
  const [type1Payments, setType1Payments] = useState<DetailedLedger[]>([]);
  
  const formRef: any = useRef();

  // Log detailed ledger when available for debugging - to remove after
  useEffect(() => {
    if (detailedLedger && detailedLedger.length > 0) {
      console.log("Detailed ledger available in payment program:", detailedLedger.length, "entries");
      
      // Log payment-related ledger entries
      const paymentEntries = detailedLedger.filter(entry => entry.payment);
      if (paymentEntries.length > 0) {
        console.log("Payment entries in detailed ledger:", paymentEntries.length);
        
        // Filter payments with payment type 1
        const paymentsOfType1 = paymentEntries.filter(entry => 
          entry.payment?.paymentTypeId === 1 && entry.payment?.isFullyRefunded === false
        ); // also not fully refunded logic
        
        if (paymentsOfType1.length > 0) {
          console.log("Payments of type 1:", paymentsOfType1.length);
          console.log("Payment type 1 entries:", paymentsOfType1);
        } else {
          console.log("No payments of type 1 found in the detailed ledger");
        }
      }
    }
  }, [detailedLedger]);

  useEffect(() => {
    // Process detailed ledger to extract relevant payment information when available
    if (detailedLedger && detailedLedger.length > 0) {
      console.log("Processing detailed ledger for payment program information");
      
      // Extract payment entries from detailed ledger
      const paymentEntries = detailedLedger.filter(entry => entry.payment);
      
      if (paymentEntries.length > 0) {
        // Process payment entries to complement existing payment information
        // This could be used to enhance the payment program display
        console.log("Payment entries found in detailed ledger:", paymentEntries.length);
        
        // Example: Find recurring payments, down payments, etc.
        const downPaymentEntries = paymentEntries.filter(entry => 
          entry.payment?.paymentTypeId === PAYMENT_TYPES.DOWN_PAYMENT.paymentTypeId ||
          entry.payment?.paymentTypeId === PAYMENT_TYPES.AT_FACILITY.paymentTypeId
        );
        
        if (downPaymentEntries.length > 0) {
          console.log("Down payment entries from detailed ledger:", downPaymentEntries.length);
          // These could be used to enhance or replace the existing downPayments array
          // if not already available through the standard Redux state
        }
      }
    }
  }, [detailedLedger]);

  const reversalIdArray = Array.isArray(detailedLedger)
    ? detailedLedger
      .filter((item): item is DetailedLedger => !!item && !!item.reversal)
      .map(item => item.reversal?.paymentReversalId)
      .filter((id): id is number => id !== undefined)
    : [];

  const paymentIdArray = Array.isArray(detailedLedger)
  ? detailedLedger
    .filter((item): item is DetailedLedger => !!item && !!item.payment)
    .map(item => item.payment?.paymentId)
    .filter((id): id is number => id !== undefined)
  : [];

  const handleResendReceipt = (receiptEmail: string) => {
    if (paymentIdArray.includes(paymentId as number)) {
        dispatch(resendPaymentReceipt({ 
            transactionId: paymentId as number, 
            receiptEmail 
        }));
    } 
    else if (reversalIdArray.includes(paymentId as number)) {
        dispatch(resendRefundReceipt({ 
            transactionId: paymentId as number, 
            receiptEmail 
        }));
    } 
    else {
        console.error('Transaction ID not found in either array, or payment status is invalid.');
    }
    setIsReceiptModalOpen(false);
  }

  const handleShowMessage = () => {
    setCopiedToClipboardMsg(true)

    setTimeout(() => {
      setCopiedToClipboardMsg(false)
    }, 4000);
  }

  const resendReceiptButton = {
    menuText: "Resend Receipt",
    refundMenuText: "Resend Refund Receipt",
    modalTitle: "Receipt"
  };


  const stateFields = {
    paymentProgram: useSelector((state: RootState) => state?.patientContext?.selectedEncounter?.patientPaymentProgram?.length > 0 ?
      state.patientContext.selectedEncounter.patientPaymentProgram[state.patientContext.selectedEncounter.patientPaymentProgram.length - 1] : {} as PatientPaymentProgram),
    selectedEncounter: useSelector((state: RootState) => state.patientContext.selectedEncounter),
    selectedPatient: useSelector((state: RootState) => state.patientContext.selectedPatient),
    userName: useSelector((state: RootState) => state.userContext.userProfile.userName),
    transactions: useSelector((state: RootState) => state.patientContext.selectedEncounter?.patientTransactions?.length > 0 && state.patientContext.selectedEncounter.patientTransactions),
    recurringPayment: useSelector((state: RootState) => {
      // Get the recurring payment method for the current encounter by filtering payment methods
      // that are marked as recurring and match the current encounter ID
      if (state.patientContext.selectedEncounter?.patientPaymentMethods?.length > 0) {
        const recurringPayment = state.patientContext.selectedEncounter.patientPaymentMethods.filter((method) => {
          return (method.metadata?.metaData_paymentMethodType?.includes("RECURRING") || method?.metadata?.isRecurring) && 
                 method.metadata?.metaData_encounterId === state.patientContext.selectedEncounter.patientEncounterId.toString()
        })
        return recurringPayment ? recurringPayment[0] : {} as StripePaymentMethod
      } else {
        return {} as StripePaymentMethod
      }
    }),
    isDownPaymentLoading: useSelector((state: RootState) => state.patientContext.isLoading.patientTransactions),
    isRecurringPaymentLoading: useSelector((state: RootState) => state.patientContext.isLoading.paymentMethods),
    isDownPaymentFetchError: useSelector((state: RootState) => state.patientContext.isError.patientTransactions),
    isRecurringPaymentFetchError: useSelector((state: RootState) => state.patientContext.isError.paymentMethods),
    lockingModalOpenStatus: useSelector((state: RootState) => state.patientRecordLockingContext.lockingModalOpenStatus),
    patientModalOpenStatus: useSelector((state: RootState) => state.patientRecordLockingContext.patientModalOpenStatus),
    isLockStatusReleased_paymentPrograms: useSelector((state: RootState) => state.patientRecordLockingContext.isLockStatusReleased_paymentPrograms),
    lockRequestedById: useSelector((state: RootState) => state.patientRecordLockingContext.lockRequestedById),
    isAccountHolderUser: useSelector((state: RootState) => state.userContext.userProfile.userRole.roleName === userRoles.accountHolder),
    missingAddressError: useSelector((state: RootState) => state.patientContext.isError.missingAddress),
    paymentProgramUpdateRequired: useSelector((state: RootState) => state?.patientContext?.isError?.paymentProgramNeedsUpdate),
    userRoleId: useSelector((state: RootState) => state.userContext.userProfile.userRole.userRoleId),
    paymentMethods: useSelector((state: RootState) => state.patientContext.selectedEncounter?.patientPaymentMethods?.length > 0
      && state.patientContext.selectedEncounter.patientPaymentMethods),
    allClients: useSelector(
      (state: RootState) =>
        state.implementationContext?.implementationSpecialistClient
          ?.allClients
    ),
    currentContact: useSelector((state: RootState) => state?.patientContext?.selectedPatient?.contact),
    userProfile: useSelector((state: RootState) => state.userContext.userProfile),
    patient: useSelector((state: RootState) => state.patientContext.selectedPatient),
    currentClientBusinessRule: useSelector((state: RootState) => {
      return state.implementationContext.implementationSpecialistClient.currentClientBusinessRules as ClientBusinessRules
    }),
  }
  const {
    paymentProgram, selectedEncounter, selectedPatient, userName, transactions, recurringPayment, userRoleId, paymentMethods,
    isDownPaymentLoading, isRecurringPaymentLoading, isDownPaymentFetchError, isRecurringPaymentFetchError,
    lockingModalOpenStatus, patientModalOpenStatus, isLockStatusReleased_paymentPrograms, lockRequestedById,
    isAccountHolderUser, missingAddressError, paymentProgramUpdateRequired, allClients, currentContact, userProfile, patient, currentClientBusinessRule
  } = stateFields;

  const doAnyAchPaymentsOrPaymentMethodsExist = patientHelper.checkNonRefundedAchTransactionsOrPaymentMethods(transactions, paymentMethods);
  // let downPayments = transactions ? patientHelper.getNonRefundedDownPayments(transactions) : [];
  // Use Redux downpayments if available and have details loaded, otherwise use type1Payments
  let downPayments = (selectedIocDownPmts && selectedIocDownPmts.length > 0 && selectedIocDownPmts[0]?.detailsLoaded) 
    ? selectedIocDownPmts 
    : type1Payments;
  // TODO: move type1Payments to backend and move this logic (FPS-10320)
  const handleRefreshTransactions = async () => {
    await LedgerUtils.fetchLedger({
      encounterId: selectedEncounter.patientEncounterId,
      dispatch,
    });
  }

  const handleRefreshPaymentMethods = async () => {
    if (!missingAddressError) {
      await dispatch(getPaymentMethods({
        patientId: selectedEncounter?.patientId,
        encounterId: selectedEncounter?.patientEncounterId
      }));
    }
  }

  let emptyclipboard: Clipboard = EmptyClipBoard;

  useEffect(() => {
    const copay = Utils.arrayToString(selectedEncounter.patientInsurance, clipboardKeys.copayAmt, formats.usd)
    const coInsurance = Utils.arrayToString(selectedEncounter.patientInsurance, clipboardKeys.coinsuranceAmt, formats.percentage)
    const deductible = Utils.arrayToString(selectedEncounter.patientInsurance, clipboardKeys.deductibleAmt, formats.usd)
    const OOPM = Utils.arrayToString(selectedEncounter.patientInsurance, clipboardKeys.oopmaxAmt, formats.usd)
    const insuranceCompanyName = Utils.arrayToString(selectedEncounter.patientInsurance, clipboardKeys.insuranceCompanyName)
    let patientChampions= "";

    if(selectedEncounter?.patientChampion?.length > 0){
      selectedEncounter?.patientChampion?.forEach((patientChampion, index)=>{
        patientChampions += `Patient Champion ${index + 1}/Relationship: ${patientChampion?.contact?.firstName}/${patientChampion?.relationshipToPatient}\n`
      })
    }

    const arrayInfo = [insuranceCompanyName, copay, coInsurance, deductible, OOPM, patientChampions]

    emptyclipboard.Down_Payment = `${formatNumberToUSD(Number(selectedEncounter?.patientPaymentProgram[selectedEncounter?.patientPaymentProgram.length-1].downPmtAmt))  || ""}`
    emptyclipboard.Patient_Name = `${selectedPatient?.contact?.firstName} ${selectedPatient?.contact?.lastName}`
    emptyclipboard.Facility = selectedEncounter?.facilityName || ""
    emptyclipboard.Occupancy_Rate = ""
    emptyclipboard.Level_of_Care = selectedEncounter?.levelOfCare || "";
    emptyclipboard.Payor_Type = selectedEncounter.payorRisk.payorRiskName || ""
    emptyclipboard.Timing_Risk = selectedEncounter.timingRisk.timingRiskName || ""
    emptyclipboard.Risk_Class = selectedEncounter?.riskClass?.riskClassName || ""
    emptyclipboard.Patient_Financial_Responsibility = `${formatNumberToUSD(Number(selectedEncounter.pfrAmt)) || ""}`
    emptyclipboard.Stated_Income = `${formatNumberToUSD(Number(selectedPatient.contact.contactIncome?.yearlySalary))  || ""}`
    emptyclipboard.Income_Verification_Score = `${selectedPatient.contact.contactIncome?.verificationScore  || ""}`
    emptyclipboard.Disposable_Income = `${formatNumberToUSD(Number(selectedPatient.contact.contactIncome?.disposableIncome || "")) }`

    const resultString = Utils.objectToString(emptyclipboard, arrayInfo, highRiskMessage.highRisk)
    setClipboard(resultString)
    // eslint-disable-next-line
  }, [selectedEncounter, selectedPatient])

  // const groupedTransactions = transactions ? patientHelper.consolidateTransactions(transactions, false) : []
  const isHighRisk = stateFields?.paymentProgram?.isHighRisk;
  const [isHighRiskModalOpen, setIsHighRiskModalOpen] = useState(false);
  const [isRecurringPaymentModalOpen, setIsRecurringPaymentModalOpen] = useState(false);
  const [isReleaseFundsModalOpen, setIsReleaseFundsModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [paymentId, setPaymentId] = useState<number | string | undefined>(0);
  const [isPaymentDeleteModalOpen, setIsPaymentDeleteModalOpen] = useState(false)
  const [isRecurringPaymentDeleteModalOpen, setIsRecurringPaymentDeleteModalOpen] = useState(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isDownPayment, setIsDownPayment] = useState(false);
  const [isRequestReleaseButtonDisabled, setIsRequestReleaseButtonDisabled] = useState(false);
  const [showDownPaymentDetails, setShowDownPaymentDetails] = useState(false)
  const [menuText, setMenuText] = useState("Release")
  const [maxPaymentAmt, setMaxPaymentAmt] = useState(0)
  const [totalDownPayments, setTotalDownPayments] = useState(0)
  const [isEnrollLoading, setIsEnrollLoading] = useState(false)

  const channelId = 5

  const client: ClientStatusCardViewModel | undefined = allClients.find(
    (c: ClientStatusCardViewModel) =>
        c.clientId === selectedEncounter?.clientId
  );

  const isEnrollBtnVisible = client?.paymentProgramVersion === 4 && (selectedEncounter?.patientPaymentProgram?.[0]?.patientPaymentSchedule.scheduleStatus === 'Pending' || selectedEncounter?.patientPaymentProgram?.[0]?.patientPaymentSchedule.scheduleStatus ===  null);
  const isIntegrationEnabled = client?.clientCrm?.some((crm: ClientCrm) => crm.isIntEnabled);

  const doPFRAdjustmentsExist = selectedEncounter?.doPFRAdjustmentsExist

  // Apply account holder filtering to centralized downpayments
  const filteredDownpayments = useMemo(() => {
    if (isAccountHolderUser) {
      // Apply account holder filtering - exclude ACH uncaptured payments
      return LedgerUtils.calculateDownpayments(selectedIocDownPmts, true);
    }
    return selectedIocDownPmts;
  }, [selectedIocDownPmts, isAccountHolderUser]);

  const computedDownPayments = useMemo(() => {
    return filteredDownpayments.map(ledgerEntry => ledgerEntry.payment).filter(Boolean);
  }, [filteredDownpayments]);
  
  const computedDownPaymentsSum = useMemo(() => {
    return LedgerUtils.calculateDownpaymentsSum(filteredDownpayments);
  }, [filteredDownpayments]);

  useEffect(() => {
    const isFullPay = paymentProgram.isPaidInFull && paymentProgram.patientPaymentSchedule?.paymentFreq === 'F';
    if (isFullPay) {
      setMaxPaymentAmt(paymentProgram?.patientPaymentSchedule?.pfrPendingBalance!);
    } else {
      setMaxPaymentAmt(getMaxPaymentAmt());
    }
  }, [paymentProgram, selectedEncounter, computedDownPaymentsSum]);

  const getMaxPaymentAmt = () => { 
    return paymentProgram?.downPmtAmt - computedDownPaymentsSum 
  }
  
  useEffect(() => {
    console.log(`Total down payments calculated: ${computedDownPaymentsSum}`);
    // Update state only if the sum has changed
    setTotalDownPayments(prev => (prev !== computedDownPaymentsSum ? computedDownPaymentsSum : prev));

    // Check if down payment is fully paid and update Redux state
    if (paymentProgram?.downPmtAmt !== undefined && !isAccountHolderUser) {
        if (computedDownPaymentsSum >= paymentProgram?.downPmtAmt) {
            console.log('Down payment is fully paid, updating Redux state');
            dispatch(setDownPaymentFullyPaid(true));
            // Don't show missing requirements modal when payment is complete
            setIsMissingReqModalOpen(false, true);
        } 
    }
  }, [computedDownPaymentsSum, paymentProgram?.downPmtAmt, dispatch, isAccountHolderUser]);
  
  const handleHighRiskModalClose = () => {
    setIsHighRiskModalOpen(false);
  }

  const handleMenuClick = ( // determine which type of item it is (recurring/down payment)
    event: React.MouseEvent<HTMLButtonElement>,
    rowPaymentId: number | string | undefined,
    isPaymentTypeCard: boolean,
    isDownPayment: boolean,
    paymentMethodUsed?: number
  ) => {
    paymentMethodUsed && paymentMethodUsed !== 1 ? setMenuText("Remove") : setMenuText("Release")
    setAnchorEl(event.currentTarget);
    setPaymentId(rowPaymentId);
    setIsDownPayment(isDownPayment);
  };

  const handleRecurringPaymentModalOpen = (isOpen: boolean) => {
    setIsRecurringPaymentModalOpen(isOpen);
  }

  const handleDownPaymentRecurringPaymentModalClose = () => {
    setIsRecurringPaymentModalOpen(false);
  }

  const getSelectedPayment = () => {
    const foundPayment = detailedLedger.find(
      (ledgerItem) => 
        ledgerItem.payment?.paymentId === paymentId
    )?.payment;
    return foundPayment as unknown as Payment;
  }

  const isHighRiskApproved = () => {
    if (isHighRisk) {
      return (stateFields?.paymentProgram?.highRiskApprovalDt ? true : false)
    } else {
      return true;
    }
  }

  const handleMenuClose = (menuActionType?: MenuActions) => {
    setAnchorEl(null);
    if (menuActionType === "Delete") { // del recurring payment
      setIsRecurringPaymentDeleteModalOpen(true);
    } else if (menuActionType === "Release") {
      setIsReleaseFundsModalOpen(true);
    }
  };

  async function handleReleaseFunds() {
    setIsReleaseFundsModalOpen(false);
    await dispatch(releaseCharge({patientId: selectedEncounter?.patientId, encounterId: selectedEncounter?.patientEncounterId, payment: getSelectedPayment()}))
    handleRefreshTransactions()
  }

  function handleDeletePayment(paymentTypeId: number) {
    if (paymentId) {
      dispatch(deletePatientPaymentMethod({
        patientId: selectedEncounter?.patientId,
        encounterId: selectedEncounter?.patientEncounterId,
        stripeId: (typeof paymentId === 'number') ? paymentId.toString() : paymentId,
        paymentTypeId: paymentTypeId
      }))
    }
    setIsPaymentDeleteModalOpen(false);
    setIsRecurringPaymentDeleteModalOpen(false);
  }

  const handlePaymentProgramsModalClose = () => {
    releasePatientLock();
    dispatch(setIsPaymentProgramsModalOpen(false));
    clearInterval(editModalPollingInterval);
  }

  const releasePatientLock = () => {
    setTimeout( async () => {
      await dispatch(lockIOC({lock: false})) // unlock the IOC
    }, 500);
  }

  const doModalPolling = useCallback(async(patientId: number, encounterId: number) => {
    editModalPollingInterval = setInterval(async() => {
      dispatch(editModalPoll({patientId, encounterId, userName, lockablePatientRecordSection: LockablePatientRecordSection.paymentPrograms}))
    }, lockPollingInterval);
  }, [dispatch, userName])

  useEffect(() => {
    if (isLockStatusReleased_paymentPrograms) {
      doModalPolling(selectedEncounter.patientId, selectedEncounter.patientEncounterId);
      dispatch(setLockStatusReleased_paymentPrograms(false));
    }
  }, [dispatch, doModalPolling, setLockStatusReleased_paymentPrograms, selectedEncounter.patientId, selectedEncounter.patientEncounterId])

  const handleEditPaymentProgram = async() => {
    dispatch(setIsPaymentProgramsModalOpen(true));

    const patientId = selectedEncounter.patientId;
    const encounterId = selectedEncounter.patientEncounterId;

    const instanceOfCare = await patientService.getPatientInstanceOfCare({patientId, encounterId});
    const {isLocked} = instanceOfCare.entity || false; // Needed to add the default value to avoid undefined for brand new patient
    if (isLocked && instanceOfCare.entity.lockedByUserId !== userName && instanceOfCare.entity.lockedByUserId !== null) { // extra checks in case of bad data
      setIsRequestReleaseButtonDisabled(false);
      dispatch(setLockRequestedById(instanceOfCare.entity.lockedByUserId));
      dispatch(setInUseModalOpen_paymentPrograms(true));
    } else {
      // patient not locked by anyone. Go ahead and lock it for me so others are locked out
      dispatch(setLockRequestedById(undefined));
      await dispatch(lockIOC({lock: true, username: userName}))

      doModalPolling(patientId, encounterId);
    }
  }

  const handleRequestReleaseOk = async() => {
    setIsRequestReleaseButtonDisabled(true);
    dispatch(requestReleaseOk({userName: userName, lockablePatientRecordSection: LockablePatientRecordSection.paymentPrograms}));
  }

  const handleRequestReleaseCancel = () => {
    navigate("/specialist/dashboard");
    resetRedux();
    dispatch(setInUseModalOpen_paymentPrograms(false));
  }

  const handleReleaseRecordOk = async() => {
    dispatch(releaseRecordOk({lockablePatientRecordSection: LockablePatientRecordSection.paymentPrograms}));
    dispatch(setIsPaymentProgramsModalOpen(false));
    clearInterval(editModalPollingInterval);
  }

  const handleRequestDeniedClose = () => {
    resetRedux();
    navigate("/specialist/dashboard");
    dispatch(setRequestDeniedModalOpen_paymentPrograms(false));
  }

  const resetRedux = () => {
    dispatch(resetPatientContext());
    dispatch(resetPatientRecordLockingContext());
  }


  // const getCumulativePaymentsAmt = () => {
  //   let existingPaymentsSum = 0;
  //   downPayments && downPayments?.length > 0 && downPayments.forEach((downPayment: Payment) => {
  //     existingPaymentsSum += downPayment?.paymentAmt;
  //   })
  //   return existingPaymentsSum;
  // }

  const isPossibleToAddPayor = ((paymentProgram?.downPmtAmt - computedDownPaymentsSum) > 0)
  const isZeroDown = selectedEncounter?.patientPaymentProgram?.length > 0 && selectedEncounter?.patientPaymentProgram?.[selectedEncounter?.patientPaymentProgram.length - 1].downPmtAmt === 0;

  const isZeroDownZeroRecurring = isZeroDown
    && selectedEncounter?.patientPaymentProgram?.[selectedEncounter?.patientPaymentProgram.length - 1].patientPaymentSchedule.terms === 0 
    && selectedEncounter?.patientPaymentProgram?.[selectedEncounter?.patientPaymentProgram.length - 1].patientPaymentSchedule.paymentDueAmt === 0
    && selectedEncounter?.patientPaymentProgram?.[selectedEncounter?.patientPaymentProgram.length - 1].patientPaymentSchedule.paymentFreq !== 'F';

  useEffect(() => {
    dispatch(setDownPaymentFullyPaid(!isPossibleToAddPayor));
  }, [dispatch, isPossibleToAddPayor])

  const financialResponsibilityHeader = (
    <>
      <Grid
        container
        spacing={2}
        className="pb-3"
      >
        <Grid item xs={10}>
          <Typography variant="subtitle2">
            Patient Financial Responsibility
          </Typography>
        </Grid>
        <Grid item xs={2}>
          {(!(selectedEncounter?.workflow?.workflowId === 3)) && (
            <Box display="flex" justifyContent="flex-end" marginTop="-1.2rem" marginRight="-1.5rem">
              <AccessControl rolePageName={RolePageNames.PatientRecords} actionName="Add Instance of Care"
                renderNoAccess={() => <IconButton disabled size="large"> <EditIcon className="colorDisabled" /></IconButton>}>
                <IconButton onClick={() => handleEditPaymentProgram()} size="large" test-id="edit-payment-program-button"> <EditIcon className="icon" /> </IconButton>
              </AccessControl>
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  )

  const sectionHeader = (startString: string, endString: string) => (
    <>
      <Grid item xs={6}>
        <Typography variant="h3">
          {startString}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Box display="flex" justifyContent="flex-end">
          <Typography variant="h3">
            {endString}
          </Typography>
        </Box>
      </Grid>
    </>
  )

  const paymentFrequencyDetails = () => {
    let paymentPlanType = '';
    if (!!paymentProgram?.patientPaymentSchedule?.paymentFreq) {
      switch (paymentProgram?.patientPaymentSchedule?.paymentFreq) {
        case 'M':
          paymentPlanType = 'Monthly'
          break;
        case 'W':
          paymentPlanType = 'Weekly'
          break;
        case 'D':
          paymentPlanType = 'Daily'
          break;
        case 'F':
          paymentPlanType = 'Full Payment'
          break;
        default:
          paymentPlanType = paymentProgram?.patientPaymentSchedule?.paymentFreq
          break;
      }
    }
    return (
      <Grid container spacing={2} className="pb-5">
        {(!!paymentProgram?.patientPaymentSchedule?.paymentFreq) && (
          sectionHeader('Payment Plan Type', paymentPlanType)
        )}
      </ Grid>
    )
  }

  const handleEnrollFlow = async () => {
    try {
      await Utils.enroll({
        selectedEncounter,
        paymentProgram,
        downPayments,
        isCovertDisabled,
        isZeroDownZeroRecurring,
        setIsMissingReqModalOpen,
        setIsEnrollLoading,
        dispatch,
        userName,
        computedDownPaymentsSum,
        client,
        isIntegrationEnabled,
        isEnrollFlow: true,
        selectedPatient: patient,
        isZeroDown,
        clientCrm: client?.clientCrm,
        processError: (response) => {
          dispatch(showErrorStatus(response.entity?.message || response.errorMessage));
        },
        processUserRecord: async (email, isUpdateOnly, callback, options) => {
          try {
            const userInfo = await userService.getAllUsers(0, ApiBatchLimits.users, { userName: email });
            if (userInfo?.entity?.length > 0) {
              return userInfo.entity[0];
            } else {
              // Create new user if not found
              const userClientScopeToSave = new UserInfoClient();
              userClientScopeToSave.clientId = selectedEncounter?.clientId;
              userClientScopeToSave.isFacilityLevel = true;
              userClientScopeToSave.allowedFacilities = [];
              
              const userToCreate = {
                userName: email,
                firstName: options.firstName,
                lastName: options.lastName,
                userScope: "FINPAY",
                clientId: selectedEncounter?.clientId,
                entityId: 0,
                isActive: true,
                isPatient: true,
                convRunNum: 1,
                userRole: {
                  userRoleId: 4,
                  roleName: "Account Holder",
                  roleDesc: "User Role for Patients or Patient Guarators",
                  roleType: "E",
                  isActive: true
                },
                allowedClients: [userClientScopeToSave]
              };
              
              const newUser = await userService.createOrUpdateUser(userToCreate);
              return newUser.entity;
            }
          } catch (error) {
            console.error("Error processing user record:", error);
            dispatch(showErrorStatus((error as Error).message));
            throw error;
          }
        },
        mapToDownPayment: () => {
          const currentDateTime = new Date();
          const tempEmailAddress = "junk@finpay.com";
          
          return {
            paymentId: 0,
            isManual: true, 
            isAuthExpired: false,
            paymentGroupId: `${paymentProgram?.patientPaymentSchedule?.patientPaymentScheduleId}`,
            patientPaymentScheduleId: paymentProgram?.patientPaymentSchedule?.patientPaymentScheduleId,
            patientId: selectedEncounter.patientId,
            patientEncounterId: selectedEncounter.patientEncounterId,
            paymentAmt: 0,
            paymentType: PAYMENT_TYPES.DOWN_PAYMENT,
            paymentInitDt: currentDateTime.toISOString(),
            isAuthOnly: true,
            receiptEmail: tempEmailAddress,
            paymentChannelId: channelId
          };
        }
      });
    } catch (error) {
      console.error('Enrollment failed:', error);
      dispatch(showErrorStatus((error as Error).message));
    }
  };

  const listItem = (
    <>
      <Grid container spacing={2} className="mx-1 mt-0_5" style={isHighRisk ? {border: '2px solid #DF1E44'} : {}}>
        <Grid item xs={2} >
          <Typography variant="h4">
            {paymentProgram?.patientPaymentSchedule?.terms}
          </Typography>
        </Grid>
        <Grid item xs={isEnrollBtnVisible ? 4 : 5}>
          <Typography variant="h4"
          test-id="down-payment-amount"
          >
            {formatNumberToUSD(paymentProgram?.downPmtAmt)}
          </Typography>
        </Grid>
        <Grid item xs={isEnrollBtnVisible ? 4 : 5}>
          <Typography variant="h4">
            {formatNumberToUSD(paymentProgram?.patientPaymentSchedule?.paymentDueAmt)}
          </Typography>
        </Grid>
        {isEnrollBtnVisible && (
        <Grid item xs={2} data-testid='payment-program-enroll-button' style={{ marginTop: '-12px' }}>
          <Button
            loading={isEnrollLoading}
            disabled={false}
            onClick={async () => {
              try {
                await handleEnrollFlow();
                // Success handling
              } catch (error) {
                // Additional error handling if needed
                console.error('Enrollment failed:', error);
              }
            }}
            spinnerLeftPosition={5}
            test-id="payment-program-enroll-button"
          >
            Enroll
          </Button>
        </Grid>
        )}
      </Grid>
    </>
  );

  // const showStatus = (payment: Payment) => !(payment?.paymentMethodUsed?.ach && !payment?.isCaptured && !(selectedEncounter?.workflow?.workflowId === 3));
  const showStatus = (payment: DetailedLedger) => true;

  const [disputeIdArray] = useState<number[]>([]);

  const downPaymentOccurenceItem = (detailedLedger: DetailedLedger, isGreyBackground: boolean) => {
    // Note: Dispute filtering is now handled by LedgerUtils.calculateDownpayments()
    // which properly excludes payments with pending/lost disputes but includes won disputes
    
    // If details aren't loaded yet, return null (component will use Redux downpayments instead)
    if (!detailedLedger.detailsLoaded || !detailedLedger.payment) {
      return null;
    }
    
    let shortDate = "", fullDate = ""
    if(detailedLedger.payment?.paymentInitDt) {
      let arrayDate = Utils.convertISODate(new Date(detailedLedger.payment?.paymentInitDt), showDownPaymentDetails).split(" ")
      shortDate = arrayDate[0]
      if(showDownPaymentDetails) fullDate = `${arrayDate[1]} ${arrayDate[2]} `
    }

    // Get last 4 digits for display when details are toggled
    const getLastFourDigits = () => {
      // Check for Redux payment objects
      if (detailedLedger.payment?.last4) {
        return `Ending in (${detailedLedger.payment?.last4})`;
      } 
      // For type 1 payments from detailedLedger
      else if (type1Payments && type1Payments.length > 0) {
        const matchingPayment = type1Payments.find(p => p.payment?.paymentId === detailedLedger.payment?.paymentId);
        if (matchingPayment?.payment?.last4) {
          return `Ending in (${matchingPayment.payment.last4})`;
        }
      }
      return "Ending in (N/A)";
    };

    return <>
      <Grid container spacing={2} className="mx-1 pr-2 mt-2" style={isGreyBackground ? {backgroundColor: '#f5f7f9'} : {}}>
        <Grid item xs={2}>
          <Typography variant="body2" style={{ display: 'flex', alignItems: 'center' }}>
              {shortDate}
          </Typography>
          <Typography variant="body2" style={{ display: 'flex', alignItems: 'center' }}>
              {fullDate}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="body2" style={{ display: 'flex', alignItems: 'center' }}>
            {Utils.getPaymentTypeName(detailedLedger.payment as V2PaymentDetail, false)} 
          </Typography>
        </Grid>
        <Grid item xs={4}>
          {(showStatus(detailedLedger)) && (
            <Typography variant="body2" className="pl-2" style={{ display: 'flex', alignItems: 'center' }}>
              <Status
                text={detailedLedger?.payment?.paymentStatus && detailedLedger?.payment?.paymentStatus.toLowerCase() === 'success'
                  ? "Success"
                  : detailedLedger?.payment?.paymentStatus && detailedLedger?.payment?.paymentStatus.toLowerCase() === 'pending'
                    ? (detailedLedger?.payment?.paymentMethodTypeId === PAYMENT_METHOD_TYPES.CARD.paymentMethodTypeId
                      ? "Uncaptured"
                      : "Pending")
                    : "Uncaptured"}
                statusColor={
                  detailedLedger?.payment?.paymentStatus === PaymentStatus.failed ? StatusColors.error :
                  (detailedLedger?.payment?.paymentStatus === PaymentStatus.success && detailedLedger?.payment?.isCaptured) ? StatusColors.success :
                  ((detailedLedger?.payment?.paymentStatus === PaymentStatus.pending || !detailedLedger?.payment?.isCaptured) ? StatusColors.warning
                  : StatusColors.error)
                }
              />
            </Typography>
          )}
          <Typography variant="body2" className="break-word pl-2" style={{ display: 'flex', alignItems: 'center' }}>
            {showDownPaymentDetails ? getLastFourDigits() : ""}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" style={{ display: 'flex', alignItems: 'center' }}>
            {formatNumberToUSD(detailedLedger?.payment?.paymentAmt)}
          </Typography>
          <Typography variant="body2" className="break-word" test-id="down-payment-id-value" style={{ display: 'flex', alignItems: 'center' }}>
            {showDownPaymentDetails && (
              Utils.getExternalPaymentId(detailedLedger)
            )}
          </Typography>
        </Grid>
        <Grid item xs={1} style={{marginTop: -12, maxHeight: 10}}>
          {!(detailedLedger?.payment?.isCaptured && detailedLedger?.payment?.paymentMethodTypeId === 2) && (detailedLedger?.payment?.paymentAmt !== 0) && (
            <TransactionMenu
              testId={`payment-program-down-payment-submenu-open-${detailedLedger?.payment?.paymentId}`}
              transactionData={{
                transactionId: detailedLedger?.payment?.paymentId as number,
                isPaymentTypeCard: detailedLedger?.payment?.paymentMethodTypeId === PAYMENT_METHOD_TYPES.CARD.paymentMethodTypeId,
                paymentStatus: detailedLedger?.payment?.paymentStatus as string,
                paymentTypeId: detailedLedger?.payment?.paymentTypeId as number,
                isPaymentCaptured: detailedLedger?.payment?.isCaptured,
                isCaptured: detailedLedger?.payment?.isCaptured,
                paymentMethodTypeId: detailedLedger?.payment?.paymentMethodTypeId as number,
                paymentId: detailedLedger?.payment?.paymentId
              }}
              detailedLedger={[detailedLedger]}
              reversalIdArray={[]}
              reversalPaymentOriginArray={[]}
              disputeIdArray={disputeIdArray}
              isAccountHolder={isAccountHolderUser}
              workflowId={selectedEncounter?.workflow?.workflowId}
              onRefund={(transactionId, menuTexts) => {
                setPaymentId(transactionId);
                setMenuText(menuTexts.menuText);
                setIsReleaseFundsModalOpen(true);
              }}
              onResendReceipt={(transactionId, isRefund) => {
                setPaymentId(transactionId);
                setIsReceiptModalOpen(true);
              }}
              onNavigateToDispute={() => {/* Not implemented in current component */}}
              resendReceiptButton={{
                menuText: "Resend Receipt",
                refundMenuText: "Resend Refund Receipt",
                modalTitle: "Resend Receipt"
              }}
            />
          )}
        </Grid>
      </Grid>
    </>;
  }


  const recurringPaymentOccurenceItem = (payment: StripePaymentMethod) => (
    <>
      <Grid container spacing={2} className="mx-1 pr-2 px-1 mt-0_5" data-testid="recurring-payment-items">
        <Grid item xs={5} >
          <Typography variant="h4" style={{ display: 'flex', alignItems: 'center' }}>
            {payment?.name}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="h4" style={{ display: 'flex', alignItems: 'center' }}>
            {(payment?.object === 'card') ? "Credit Card" : "ACH"}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="h4" style={{ display: 'flex', alignItems: 'center' }}
          test-id="recurring-payment-amount">
            {formatNumberToUSD(paymentProgram?.patientPaymentSchedule?.paymentDueAmt)}
          </Typography>
        </Grid>
        <Grid item xs={1} style={{marginTop: -12, maxHeight: 10}} className="pr-3">
          {(!(selectedEncounter?.workflow?.workflowId === 3)) && (
            <>
              <IconButton
                aria-haspopup="true"
                onClick={(e) => {
                  const isPaymentTypeCard = (payment && (payment?.object === 'card'))
                  const isDownPayment = false
                  handleMenuClick(e, payment?.id, isPaymentTypeCard, isDownPayment, 0)
                }}
                size="large">
                <MoreHorizIcon />
              </IconButton>
            </>
          )}
        </Grid>
      </Grid>
    </>
  );


  const highRiskDetails = ( // supporting components for when the terms are high risk
    <>
      <Grid container spacing={1} className="pt-3 px-2 mt-4">
        <Grid item xs={8}>
          <Typography variant="h4">
            Step 1
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Fade in={copiedToClipboardMsg}>
              <Typography variant="h3" color="primary" className="px-0" align="center">
                Copied to clipboard
              </Typography>
          </Fade>
        </Grid>
        <Grid item xs={6} className="ml-4">
          <Typography variant="h4">
            Email the facility with the details of this instance of care
          </Typography>
        </Grid>
        <Grid item xs={5} className="ml-4 w-100">
          <Box display="flex" justifyContent="flex-end" marginRight="-5rem">
            <CopyToClipboard text={clipboard} onCopy={() => handleShowMessage()}>
              <Button type="text">
                Copy Details
              </Button>
            </CopyToClipboard>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h4">
            Step 2
          </Typography>
        </Grid>
        <Grid item xs={6} className="ml-4">
          <Typography variant="h4">
            Approve High Risk Exception and provide details received from the Facility
          </Typography>
        </Grid>
        <Grid item xs={5} className="ml-4">
          <Box display="flex" justifyContent="flex-end" marginRight="-2rem">
            <AccessControl rolePageName={RolePageNames.PatientRecords} actionName="Add Instance of Care"
              renderNoAccess={() => <Button disabled>Approve</Button>}>
              <Button test-id="approve-high-risk-button" onClick={() => setIsHighRiskModalOpen(true)}>Approve</Button>
            </AccessControl>
          </Box>
        </Grid>
      </Grid>
    </>
  )

  const paymentList = (paymentTitle: string, listItems: any[], paymentAmt: string, isFetchingLedgerDetails: boolean) => {
    return (
      <>
        {isFetchingLedgerDetails ? (
          <Grid
            container
            spacing={2}
            className="pb-3 px-2 pl-4"
          >
            {sectionHeader(paymentTitle, paymentAmt)}
            <Grid container className="mx-1 pl-3 px-1 py-1 mt-3 header">
              {/* Skeleton loader for the header */}
              <Grid item xs={2}>
                <Skeleton variant="text" width="80%" height={24} />
              </Grid>
              <Grid item xs={1}>
                <Skeleton variant="text" width="80%" height={24} />
              </Grid>
              <Grid item xs={4}>
                <Skeleton variant="text" width="80%" height={24} />
              </Grid>
              <Grid item xs={4}>
                <Skeleton variant="text" width="80%" height={24} />
              </Grid>
              <Grid item xs={1} />
            </Grid>
            {/* Skeleton loader for multiple payment rows */}
            {[...Array(3)].map((_, index) => (
              <Grid container className="mx-1 pr-2 mt-2" key={index} style={index % 2 !== 0 ? {backgroundColor: '#f5f7f9'} : {}}>
                <Grid item xs={2}>
                  <Skeleton variant="text" width="60%" height={20} />
                  <Skeleton variant="text" width="80%" height={20} />
                </Grid>
                <Grid item xs={1}>
                  <Skeleton variant="text" width="80%" height={20} />
                </Grid>
                <Grid item xs={4}>
                  <Skeleton variant="text" width="40%" height={20} />
                  <Skeleton variant="text" width="70%" height={20} />
                </Grid>
                <Grid item xs={4}>
                  <Skeleton variant="text" width="40%" height={20} />
                  <Skeleton variant="text" width="60%" height={20} />
                </Grid>
                <Grid item xs={1} />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid
            container
            spacing={2}
            className="pb-3 px-2 pl-4"
          >
            {sectionHeader(paymentTitle, paymentAmt)}
            <Grid 
              container 
              className="mx-1 pl-3 px-1 py-1 mt-3 header"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Grid item xs={2}>
                <Typography variant="h4" style={{ minHeight: '24px', display: 'flex', alignItems: 'center' }}>
                  Initiated Date
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography variant="h4" className="break-word" style={{ minHeight: '24px', display: 'flex', alignItems: 'center' }}>
                  Type
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="h4" className="pl-3" style={{ minHeight: '24px', display: 'flex', alignItems: 'center' }}>
                  Status / Source
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="h4" style={{ minHeight: '24px', display: 'flex', alignItems: 'center' }}>
                  Amount/ ID
                </Typography>
              </Grid>
              <Grid item xs={1} />
            </Grid>
            {listItems && listItems.length > 0 ? (
              listItems.map((item: DetailedLedger, index: number) => (
                ((item?.payment?.paymentMethodTypeId === 2 && !item?.payment?.isCaptured) && isAccountHolderUser) ?
                ""
                :
                (<React.Fragment key={index}>
                  {downPaymentOccurenceItem(
                    item,
                    (index % 2 !== 0) // if there is no Payor Id, then the Payor Id is the Patient Id.
                  )}
                </React.Fragment>)
              ))
            ) : (
              <div className="no-payment-methods">No payments</div>
            )}
            <Grid container className="pt-5 mx-1 px-1 mt-5">
              {(paymentTitle === "Down Payment") && (
                <Grid container spacing={3}>
                  {sectionHeader('Estimated PFR', `${formatNumberToUSD(selectedEncounter?.pfrAmt)}`)}
                  {(doPFRAdjustmentsExist) && (
                    sectionHeader('Current PFR', `${formatNumberToUSD(selectedEncounter?.adjustedPfrAmt)}`)
                  )}
                  {sectionHeader('Down Payments', `${formatNumberToUSD(totalDownPayments)}`)}
                  {sectionHeader('Pending Remaining Balance', `${formatNumberToUSD(paymentProgram?.patientPaymentSchedule?.pfrPendingBalance)}`)}
                  {sectionHeader('Remaining Balance', `${formatNumberToUSD(paymentProgram?.patientPaymentSchedule?.pfrCapturedBalance)}`)}
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
      </>
    );
  };

  const recurringPaymentList = (paymentTitle: string, paymentAmt: string) => {
    // Check if recurring payment exists to conditionally render the table headers
    const hasRecurringPayment = recurringPayment && recurringPayment?.id;
    
    return (
      <>
        <Grid
          container
          spacing={2}
          className="pb-3 px-2 pl-4"
        >
          {sectionHeader(paymentTitle, paymentAmt)}
          
          {/* Only show table headers if recurring payment exists */}
          {hasRecurringPayment && (
            <Grid 
              container 
              className="mx-1 pl-3 px-1 py-1 mt-3 header"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Grid item xs={5}>
                <Typography variant="h4" style={{ minHeight: '24px', display: 'flex', alignItems: 'center' }}>
                  Payor
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography variant="h4" style={{ minHeight: '24px', display: 'flex', alignItems: 'center' }}>
                  Payment Type
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="h4" style={{ minHeight: '24px', display: 'flex', alignItems: 'center' }}>
                  Amount
                </Typography>
              </Grid>
              <Grid item xs={1} />
            </Grid>
          )}
          
          {/* Display recurring payment if exists */}
          {hasRecurringPayment && recurringPaymentOccurenceItem(recurringPayment)}
          
          {/* Conditionally show buttons based on workflow status only */}
          {(selectedEncounter?.workflow?.workflowId === 3) ? (
            <div>
              <Button
                type="text"
                icon={<AddIcon />}
                paddingLeft={0}
                onClick={() => handleRecurringPaymentModalOpen(true)}
                disabled={!isHighRiskApproved()}
              >
                Update Recurring Payment Method
              </Button>
            </div>
          ) : (
            !hasRecurringPayment && selectedEncounter?.workflow?.workflowId !== 3 && (
              <div test-id="add-recurring-payment-btn">
                <Button
                  type="text"
                  icon={<AddIcon />}
                  paddingLeft={0}
                  onClick={() => handleRecurringPaymentModalOpen(true)}
                  disabled={!isHighRiskApproved()}
                  
                >
                  Add Payor
                </Button>
              </div>
            )
          )}
        </Grid>
      </>
    )
  }

  const initialValues = {
    showDownPaymentDetails: false,
  }

  const validationSchema = Yup.object({
    showDownPaymentDetails: Yup.boolean(),
  })

  function checkIfIsValid(value: { showDownPaymentDetails: boolean }) {
    setShowDownPaymentDetails(value.showDownPaymentDetails);
    validationSchema
      .validate(value)
  }

  // Update useEffect to set type1Payments from detailedLedger
  const createDetailedLedger = useMemo(() => detailedLedger, [JSON.stringify(detailedLedger)]);

  useEffect(() => {
    if (createDetailedLedger && createDetailedLedger.length > 0) {
      // Use LedgerUtils.calculateDownpayments to properly handle disputes
      const paymentsOfType1 = LedgerUtils.calculateDownpayments(createDetailedLedger, false);
      
      
      // Only update state if the new value is different
      setType1Payments(prev =>
        (prev.length !== paymentsOfType1.length) ? paymentsOfType1 : prev
      );
    } else {
      console.log("No detailed ledger available to calculate downpayments");
      setType1Payments([]);
    }
  }, [createDetailedLedger]);


  const accordionContents = (
    <>
      <Grid item xs={12} className="mt-2 mb-4">
        <Divider />
      </Grid>
      {isDownPaymentFetchError ? (
        <>
          <Grid item xs={10}>
            <Typography variant="h4">
              Transactions Pending. Use Refresh button to update.
            </ Typography>
          </Grid>
          <Grid item xs={2}>
            <Box display="flex" justifyContent="flex-end" marginTop="-1.2rem" marginRight="-1.5rem">
              <IconButton onClick={() => handleRefreshTransactions()} size="large">
                <RefreshIcon className="icon" />
              </IconButton>
            </Box>
          </Grid>
        </>
      ) : (
        <>
          {isHighRisk && (selectedEncounter?.workflow?.workflowId === 3) && !isHighRiskApproved() && (
            <Grid container direction="row" justifyContent="space-between" spacing={5} className="mb-1">
              <Grid container item xs={7} >
                <Fade in={copiedToClipboardMsg}>
                  <Typography variant="h3" color="primary" className="px-0">
                    Copied to clipboard
                  </Typography>
                </Fade>
              </Grid>
              <Grid container item xs={3}  >
                <Box display="flex"    >
                  <CopyToClipboard text={clipboard} onCopy={() => handleShowMessage()}>
                    <Button type="text">
                      Copy Details
                    </Button>
                  </CopyToClipboard>
                </Box>
              </Grid>
            </Grid>
          )}
          {/* Check both Redux state downPayments and detailedLedger type1Payments */}
          {((downPayments && downPayments.length > 0) || (type1Payments && type1Payments.length > 0)) ? (
            <>
              {!isAccountHolderUser && (
                <Grid container className="my-4 ml-2">
                  <Grid xs={12} item>
                    <Typography variant="h3" className="mb-2">
                      Details
                    </Typography>
                  </Grid>
                  <Grid xs={12} item>
                    <Formik
                      innerRef={formRef}
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      validate={checkIfIsValid}
                      onSubmit={() => {}}
                    >
                      {(formik) => (
                        <Form>
                          <div className="mb-6">
                            <Toggle
                              name="showDownPaymentDetails"
                              formik={formik}
                              value={formik.values.showDownPaymentDetails}
                            />
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Grid>
                </Grid>
              )}
              {/* Use downPayments (type1Payments) which are DetailedLedger objects from LedgerUtils.calculateDownpayments */}
              {paymentList('Down Payment', 
                downPayments, 
                `${formatNumberToUSD(paymentProgram?.downPmtAmt)}`, isFetchingLedgerDetails)}
            </>
            ) : (
              isDownPaymentLoading ? (
                <Grid item xs={12} className="px-3">
                  {/* Replace LoadingOverlay with Skeleton */}
                  <Grid container spacing={2} className="pb-3 px-2 pl-4">
                    <Grid item xs={6}>
                      <Skeleton variant="text" width="60%" height={24} />
                    </Grid>
                    <Grid item xs={6}>
                      <Box display="flex" justifyContent="flex-end">
                        <Skeleton variant="text" width="40%" height={24} />
                      </Box>
                    </Grid>
                    {/* Payment row skeleton */}
                    <Grid item xs={12}>
                      <Skeleton variant="rectangular" width="100%" height={48} />
                    </Grid>
                    <Grid item xs={12}>
                      <Skeleton variant="text" width="20%" height={36} />
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <>
                  {(!(selectedEncounter?.workflow?.workflowId === 3)) && (
                    <>
                      {sectionHeader('Down Payment', `${formatNumberToUSD(paymentProgram?.downPmtAmt)}`)}
                      {isZeroDown && (
                          <Typography 
                            variant="h4" 
                            style={{ paddingLeft: "16px", fontStyle: "italic" }}
                          >
                            No down payment required.
                          </Typography>
                        )}
                    </>
                  )}
                </>
              )
          )}
        </>
      )}
      {(!(paymentProgram?.patientPaymentSchedule?.paymentFreq === 'F')) && (
        <Grid item xs={12} className="mt-2 mb-4">
          <Divider />
        </Grid>
      )}
      {(!(paymentProgram?.patientPaymentSchedule?.paymentFreq === 'F')) && (
        isRecurringPaymentFetchError ? (
          <>
            <Grid item xs={10}>
              <Typography variant="h4">
                Payment Methods Pending. Use Refresh button to update.
              </ Typography>
            </Grid>
            <Grid item xs={2}>
              <Box display="flex" justifyContent="flex-end" marginTop="-1.2rem" marginRight="-1.5rem">
                <IconButton onClick={() => handleRefreshPaymentMethods()} size="large">
                  <RefreshIcon className="icon" />
                </ IconButton>
              </ Box>
            </Grid>
          </>
        ) : (
          isRecurringPaymentLoading ? (
            <Grid item xs={12} className="px-3">
              {/* Replace LoadingOverlay with Skeleton */}
              <Grid container spacing={2} className="pb-3 px-2 pl-4">
                <Grid item xs={6}>
                  <Skeleton variant="text" width="60%" height={24} />
                </Grid>
                <Grid item xs={6}>
                  <Box display="flex" justifyContent="flex-end">
                    <Skeleton variant="text" width="40%" height={24} />
                  </Box>
                </Grid>
                {/* Recurring payment row skeleton */}
                <Grid item xs={12}>
                  <Skeleton variant="rectangular" width="100%" height={48} />
                </Grid>
              </Grid>
            </Grid>
          ) : (
            recurringPaymentList('Recurring Payment', `${formatNumberToUSD(paymentProgram?.patientPaymentSchedule?.paymentDueAmt)}`)
          )
        )
      )}
    </>
  )

  return (
    <div className="px-2 list-header">
      {financialResponsibilityHeader}
      {paymentFrequencyDetails()}
      <Grid
        container
        justifyContent="space-between"
        spacing={2}
        className="pb-2"
      >
        <Grid container direction="row" className="mx-1 px-1 py-1 header">
          <Grid item xs={2}>
            <Typography variant="h4">
              Terms
            </Typography>
          </Grid>
          <Grid item xs={isEnrollBtnVisible ? 4 : 5}>
            <Typography variant="h4">
              Down Payment
            </Typography>
          </Grid>
          <Grid item xs={isEnrollBtnVisible ? 4 : 5}>
            <Typography variant="h4">
              Recurring
            </Typography>
          </Grid>
          {isEnrollBtnVisible && (<Grid item xs={2} />)}
        </Grid>
        {listItem}
        {isHighRisk && !(selectedEncounter?.workflow?.workflowId === 3) && !isHighRiskApproved() && highRiskDetails}
        {accordionContents}
      </Grid>
      {isHighRiskModalOpen && (<HighRiskModal
        open={isHighRiskModalOpen}
        handleModalClose={handleHighRiskModalClose}
      />
      )}
      {isReleaseFundsModalOpen && (
        <DeleteModal
          open={isReleaseFundsModalOpen}
          title={`${menuText} Funds`}
          subTitle="This action cannot be undone"
          okButtonText={`${menuText} Funds`}
          handleDeleteCancel={() => setIsReleaseFundsModalOpen(false)}
          handleDeleteOk={handleReleaseFunds}
        />
      )}
      {isReceiptModalOpen && (
        <ResendReceiptModal
          open={isReceiptModalOpen}
          receiptEmail={selectedPatient?.contact.email}
          titleText={reversalIdArray.includes(paymentId as number) ? resendReceiptButton.refundMenuText + '?' : resendReceiptButton.menuText + '?'}
          onSend={handleResendReceipt}
          onClose={()=> setIsReceiptModalOpen(false)}
        />
      )}
      {isPaymentDeleteModalOpen && (
        <DeleteModal
          open={isPaymentDeleteModalOpen}
          title="Delete Payment"
          subTitle="This action cannot be undone"
          okButtonText="Delete"
          handleDeleteCancel={() => setIsPaymentDeleteModalOpen(false)}
          handleDeleteOk={() => handleDeletePayment(1)}
        />
      )}
      {isRecurringPaymentDeleteModalOpen && (
        <DeleteModal
          open={isRecurringPaymentDeleteModalOpen}
          title="Delete Source"
          subTitle="This action cannot be undone"
          okButtonText="Delete"
          handleDeleteCancel={() => setIsRecurringPaymentDeleteModalOpen(false)}
          handleDeleteOk={() => handleDeletePayment(2)}
        />
      )}
      {(patientModalOpenStatus.isPaymentProgramModalOpen || paymentProgramUpdateRequired) && (
        <PaymentProgramsModal
          open={patientModalOpenStatus.isPaymentProgramModalOpen || paymentProgramUpdateRequired}
          handleModalClose={handlePaymentProgramsModalClose}
          isEdit
        />
      )}
      {isRecurringPaymentModalOpen && (
        <RecurringPaymentModal
          open={isRecurringPaymentModalOpen}
          handleModalClose={handleDownPaymentRecurringPaymentModalClose}
          existingRecurringPayment={recurringPayment}
        />
      )}
      {lockingModalOpenStatus.isInUseModalOpen_paymentPrograms && <LockModal
        open={lockingModalOpenStatus.isInUseModalOpen_paymentPrograms}
        title="Instance of Care In Use"
        subTitle1={`A release request will be sent to ${lockRequestedById}`}
        subTitle2={`Access will be granted in ${countdownMax} seconds or less`}
        hasCountdown={false}
        countdownSeconds={countdownMax}
        primaryButtonType="primary"
        primaryButtonText="Request Release"
        handlePrimaryButton={handleRequestReleaseOk}
        secondaryButtonType="secondary"
        secondaryButtonText="Cancel"
        handleSecondaryButton={handleRequestReleaseCancel}
        icon={<LockIcon />}
        modalType="info"
        justifyButtons="flex-end"
        primaryButtonDisabled={isRequestReleaseButtonDisabled}
      />}

      {lockingModalOpenStatus.isRequestDeniedModalOpen_paymentPrograms && <LockModal
        open={lockingModalOpenStatus.isRequestDeniedModalOpen_paymentPrograms}
        title="Request Denied"
        subTitle1={`${lockRequestedById} will retain access to this record`}
        hasCountdown={false}
        primaryButtonType="secondary"
        primaryButtonText="Close"
        handlePrimaryButton={handleRequestDeniedClose}
        icon={<LockIcon />}
        modalType="error"
        justifyButtons="flex-end"
      />}

      {(lockingModalOpenStatus.isLockRequestedModalOpen_paymentPrograms) && <LockModal
        open={lockingModalOpenStatus.isLockRequestedModalOpen_paymentPrograms}
        title="Instance of Care Requested"
        subTitle1={`${lockRequestedById} requested this record`}
        subTitle2={`Access will be granted in ${countdownMax} seconds or less`}
        hasCountdown
        countdownSeconds={countdownMax}
        primaryButtonType="primary"
        primaryButtonText="Release Record"
        handlePrimaryButton={handleReleaseRecordOk}
        secondaryButtonType="danger"
        secondaryButtonText="Deny Request"
        handleSecondaryButton={() => dispatch(denyRequestOk({lockablePatientRecordSection: LockablePatientRecordSection.paymentPrograms}))}
        icon={<WarningRoundedIcon />}
        modalType="warning"
        justifyButtons="space-between"
      />}



      {(!(selectedEncounter?.workflow?.workflowId === 3)) && (
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => handleMenuClose()}
        >
          {isDownPayment && (
            <AccessControl rolePageName={RolePageNames.PatientRecords} actionName="Apply Payment Program"
              renderNoAccess={() => <MenuItem disabled>Release</MenuItem>}>
              <MenuItem
                onClick={() => handleMenuClose("Release")}
                className="danger"
              >
                {menuText}
              </MenuItem>
            </AccessControl>
          )}
          {(!isDownPayment) &&
            <AccessControl rolePageName={RolePageNames.PatientRecords} actionName="Apply Payment Program"
              renderNoAccess={() => <MenuItem disabled>Delete</MenuItem>}>
              <MenuItem onClick={() => handleMenuClose("Delete")} className="danger">Delete</MenuItem>
            </AccessControl>}
        </Menu>
      )}
    </div>
  );
}

export default PaymentProgramAccordionContents;
